import { INetworkFiveStarSurvey, ICenterFiveStarWeightedAverageResults } from '@nkr/models/index';
import _ from 'lodash';

interface IProps {
    detail: INetworkFiveStarSurvey,
    detailWeightedAverageResults: ICenterFiveStarWeightedAverageResults
}

const NetworkFiveStarSurveyHeaderRow = (props: IProps) => {
    let rowDetail = props.detail;
    let rowWeightedAverageResults = props.detailWeightedAverageResults;

    return (
        <>
            <tr>
                <th rowSpan={2}>Center</th>
                <th rowSpan={2}>Overall<br />Average</th>
                <th colSpan={3}>Workup Survey</th>
                <th colSpan={3}>Pre-Op Survey</th>
                <th colSpan={3}>3-day Post-Surgery Survey</th>
                <th colSpan={4}>30-day Post-Surgery Survey</th>
            </tr>
            <tr>
                <th>Treatment</th>
                <th>Convenience</th>
                <th>Facility</th>
                <th>Treatment</th>
                <th>Convenience</th>
                <th>Facility</th>
                <th>Treatment</th>
                <th>Convenience</th>
                <th>Facility</th>
                <th>Donor Surgeon</th>
                <th>Nursing Staff</th>
                <th>Pain Management</th>
                <th>Treatment of Caretaker</th>
            </tr>

            <tr>
                <th style={{ height: '30px' }}>AVERAGE</th>

                {rowWeightedAverageResults.overallAverage != 0 ?
                    <th>{rowWeightedAverageResults.overallAverage.toFixed(1)}</th>
                    :
                    <th style={{ backgroundColor: "#cccccc" }}>--</th>
                }

                {rowDetail.workupTreatment.networkAverage != 0 ?
                    <th> {rowDetail.workupTreatment.networkAverage.toFixed(1) + '(' + rowDetail.workupTreatment.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.workupConvenience.networkAverage != 0 ?
                    <th> {rowDetail.workupConvenience.networkAverage.toFixed(1) + '(' + rowDetail.workupConvenience.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.workupFacility.networkAverage != 0 ?
                    <th> {rowDetail.workupFacility.networkAverage.toFixed(1) + '(' + rowDetail.workupFacility.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.preOpTreatment.networkAverage != 0 ?
                    <th> {rowDetail.preOpTreatment.networkAverage.toFixed(1) + '(' + rowDetail.preOpTreatment.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.preOpConvenience.networkAverage != 0 ?
                    <th> {rowDetail.preOpConvenience.networkAverage.toFixed(1) + '(' + rowDetail.preOpConvenience.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.preOpFacility.networkAverage != 0 ?
                    <th> {rowDetail.preOpFacility.networkAverage.toFixed(1) + '(' + rowDetail.preOpFacility.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.surgeryTreatment.networkAverage != 0 ?
                    <th> {rowDetail.surgeryTreatment.networkAverage.toFixed(1) + '(' + rowDetail.surgeryTreatment.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.surgeryConvenience.networkAverage != 0 ?
                    <th> {rowDetail.surgeryConvenience.networkAverage.toFixed(1) + '(' + rowDetail.surgeryConvenience.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.surgeryFacility.networkAverage != 0 ?
                    <th> {rowDetail.surgeryFacility.networkAverage.toFixed(1) + '(' + rowDetail.surgeryFacility.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.postSurgerySurgeon.networkAverage != 0 ?
                    <th> {rowDetail.postSurgerySurgeon.networkAverage.toFixed(1) + '(' + rowDetail.postSurgerySurgeon.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.postSurgeryNursing.networkAverage != 0 ?
                    <th> {rowDetail.postSurgeryNursing.networkAverage.toFixed(1) + '(' + rowDetail.postSurgeryNursing.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.postSurgeryPainManagement.networkAverage != 0 ?
                    <th> {rowDetail.postSurgeryPainManagement.networkAverage.toFixed(1) + '(' + rowDetail.postSurgeryPainManagement.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }

                {rowDetail.postSurgeryCaretakerTreatment.networkAverage != 0 ?
                    <th> {rowDetail.postSurgeryCaretakerTreatment.networkAverage.toFixed(1) + '(' + rowDetail.postSurgeryCaretakerTreatment.networkAverageN + ')'} </th>
                    :
                    <th>--</th>
                }
            </tr>
        </>
    )
}

export default NetworkFiveStarSurveyHeaderRow;